export default "__VITE_ASSET__Cis0KTZo__"